(() => {
  const closeDetails = (details, restoreFocus = false) => {
    if (!details) return;
    details.open = false;
    if (restoreFocus) details.querySelector('summary')?.focus();
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const closeButton = event.target.closest('[data-ao-header-close]');
    if (closeButton) {
      closeDetails(closeButton.closest('details'), true);
      return;
    }
    const regionLink = event.target.closest('[data-ao-header-region]');
    if (regionLink) {
      closeDetails(regionLink.closest('details'));
      const region = document.getElementById('AORegion');
      window.requestAnimationFrame(() => (region?.querySelector('select') || region)?.focus({ preventScroll: true }));
    }
    document.querySelectorAll('[data-ao-header] details[open]').forEach((details) => {
      if (!details.contains(event.target)) closeDetails(details);
      else if (event.target.closest('.ao-header__mobile-panel nav a')) closeDetails(details);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openDetails = [...document.querySelectorAll('[data-ao-header] details[open]')];
    if (!openDetails.length) return;
    event.preventDefault();
    openDetails.forEach((details) => closeDetails(details, true));
  });

  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open) return;
    const header = details.closest('[data-ao-header]');
    if (!header) return;
    header.querySelectorAll('details[open]').forEach((other) => {
      if (other !== details && !other.contains(details)) closeDetails(other);
    });
    if (details.classList.contains('ao-header__search')) details.querySelector('input[type="search"]')?.focus();
  }, true);
})();
